import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import moment from 'moment'
import axios from 'axios'
import './assets/styles/custom.scss';
import VueSwal from 'vue-swal';
import Vuelidate from 'vuelidate'
import { validationMessage } from 'vuelidate-messages'
import VueBottomDialog from "vue-bottom-dialog";
import Paginate from 'vuejs-paginate'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueSwal);
Vue.use(Vuelidate);
Vue.use(validationMessage);
Vue.use(VueBottomDialog)
Vue.component('paginate', Paginate)

let baseUrl="http://syndicate.staging.property-pistol.in/api/mobile_crm/";
if(process.env.NODE_ENV === 'production'){
  baseUrl = "https://www.crm-application.in/api/mobile_crm"
}
axios.defaults.baseURL = baseUrl;
//axios interceptors
axios.interceptors.request.use(function(config) {
  store.dispatch('setLoading', true);
  if(config.url.indexOf('login') < 0 && config.url.indexOf('/forgot_password') < 0 && config.url.indexOf('/users/password') && config.url.indexOf('googleapis') < 0){
    let token = localStorage.getItem('s-o-token')
    if(token){
      config.headers.Authorization = `Token token=${token}`
    }else{
      return {
        headers: {},
        method: config.method,
        url: ""
      };
    }
  }
  config.headers['Content-Type'] = 'application/json'
  config.headers['Accept'] = 'application/json'
  return config;
}, function(err) {
  store.dispatch('setLoading', false);
  return Promise.reject(err);
});

axios.interceptors.response.use(function(response) {
  store.dispatch('setLoading', false);
  return response;
}, function(error){
  if(error.response?.status === 401){
    localStorage.removeItem('s-o-token');
    swal({
      title: "Session Expired",
      text: "You have been redirected to the login page",
      icon: "error"
    })
    .then(router.replace('/login'),
    store.dispatch('setLoading', false));
  }else{
    store.dispatch('setLoading', false);
    return Promise.reject(error);
  }
});

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('s-o-token')
  if(token && to.name === 'Login'){
    next({name: 'Home'});
  }else if(to.name !== 'Login' && to.name !== 'ForgotPassword' && to.name !== 'PasswordEdit' && !token){
    next({name: 'Login'});
  }else{
    if(to.name === 'Login' || to.name ==='ForgotPassword' || to.name === 'ResetPassword' || to.name==="PasswordEdit"){
      store.dispatch('setLayout', 'login');
    }else{
      store.dispatch('setLayout', 'default');
    }
    next();
  }
})

Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
